import { render, staticRenderFns } from "./MetadataProfile.vue?vue&type=template&id=370ab3e8&scoped=true"
import script from "./MetadataProfile.vue?vue&type=script&lang=js"
export * from "./MetadataProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370ab3e8",
  null
  
)

export default component.exports